import { useEffect } from 'react';

const DynamicFavicon = () => {
  useEffect(() => {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');

    // Draw background
    ctx.fillStyle = '#45b7d8';
    ctx.beginPath();
    ctx.arc(32, 32, 32, 0, Math.PI * 2);
    ctx.fill();

    // Draw gamepad icon
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath();
    
    // Simplified gamepad shape
    // D-pad
    ctx.fillRect(15, 25, 6, 15);
    ctx.fillRect(10, 30, 15, 5);
    
    // Buttons
    ctx.beginPath();
    ctx.arc(45, 25, 4, 0, Math.PI * 2);
    ctx.fill();
    
    ctx.beginPath();
    ctx.arc(53, 33, 4, 0, Math.PI * 2);
    ctx.fill();
    
    // Controller body
    ctx.fillRect(10, 38, 44, 10);
    ctx.beginPath();
    ctx.arc(10, 43, 5, Math.PI/2, Math.PI*3/2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(54, 43, 5, -Math.PI/2, Math.PI/2);
    ctx.fill();

    // Create a favicon link
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = canvas.toDataURL("image/x-icon");
    
    // Add to document head
    document.getElementsByTagName('head')[0].appendChild(link);
  }, []);

  return null;
};

export default DynamicFavicon;
